import template from './shopHeader.html';

class ShopHeaderController {
    /*@ngInject*/ 
    constructor($scope, $window, $q, cartService, dataContext, constants, shopUserService, $uibModal, $rootScope, fpStore) {
        this.$window = $window;
        this.$q = $q;
        this.cartService = cartService;
        this.dataContext = dataContext;
        this.constants = constants;
        this.shopUserService = shopUserService;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.fpStore = fpStore;

        $scope.$on('cartItemsChanged', (e, data) => {
            this.getCart();
        });
    }

    $onInit() {
        this.getUserInfo();
        this.getCart();

        this.dataContext.voziqService.getVoziqOffers().then((offers) => {
            this.offers = offers.filter((dto) => {
                return dto.OfferType === 'Equipment Only' || dto.OfferType === 'Coupon for Equipment';
            });

            if (this.offers && this.offers.length > 0 && this.fpStore.get('VoziqOfferOpened') !== 'true') {
                this.openVoziqDealModal();
            }
        });
    }

    openVoziqDealModal() {
        let modalInstance = this.$uibModal.open({
            template: '<fp-shop-voziq-offer-modal config="config"></fp-shop-voziq-offer-modal>',
            size: 'md',
            backdrop: 'static',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss,
                    offers: this.offers
                };
            }
        });

        modalInstance.result.then(() => {
            this.fpStore.set('VoziqOfferOpened', 'true', 'local');
        });
    }

    getUserInfo() {
        return this.dataContext.user.getUserInfo();
    }

    getCart() {
        this.isLoading = true;
        this.cartService.getCart()
            .then((response) => {
                this.cart = response.data;
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    isAuthenticated() {
        return this.dataContext.user.isAuthenticated();
    }
}

export default {
    template: template,
    bindings: {
        title: '<',
        cartUrl: '<'
    },
    controller: ShopHeaderController
};